import { render, staticRenderFns } from "./ConsuntivoQuery.vue?vue&type=template&id=240475ff&scoped=true&"
import script from "./ConsuntivoQuery.vue?vue&type=script&lang=js&"
export * from "./ConsuntivoQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240475ff",
  null
  
)

export default component.exports